export default function isReferenceField(field: string | undefined): boolean {
  if (!field) return false;
  return field.endsWith(':r') || field.endsWith(':e');
}